import { render, staticRenderFns } from "./ButtonsQuestion.vue?vue&type=template&id=e0f5236a&"
import script from "./ButtonsQuestion.vue?vue&type=script&lang=js&"
export * from "./ButtonsQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports